import { AxiosResponse } from 'axios';
import http from '../common/http';
import { Specialty } from '../components/AdminDashboard/Pages/SectorsManagement/Interfaces/Specialty';

class SpecialtiesService {
  update(payload: Specialty): Promise<AxiosResponse> {
    return http.patch(`/specialties/${payload.id}`, payload);
  }

  delete(id: string): Promise<AxiosResponse> {
    return http.delete(`/specialties/${id}`);
  }
}

export default new SpecialtiesService();
